import { observer } from "mobx-react-lite";
import React from "react";
import { ITeacherUser } from "../../../app/models/user";
import { Table } from "semantic-ui-react";
import { Link } from "react-router-dom";

const TeacherListItem: React.FC<{ user: ITeacherUser }> = ({ user }) => {
  return (
    <Table.Row>
      <Table.Cell>
        <Link to={`/admin/professores/${user.id}`}>{user.userName}</Link>
      </Table.Cell>
      <Table.Cell>{user.displayName}</Table.Cell>
      <Table.Cell>{user.email}</Table.Cell>
    </Table.Row>
  );
};

export default observer(TeacherListItem);
